import { useTranslation } from 'react-i18next'
import type { PortalSubject } from './api'

export function SubjectChips({ subjects }: { subjects: PortalSubject[] }) {
  const { t } = useTranslation('portal')
  if (!subjects.length)
    return <p className="text-sm text-muted">{t('No curriculum set for this class yet.')}</p>
  return (
    <ul className="flex flex-wrap gap-2">
      {subjects.map((s) => (
        <li
          key={s.name}
          className="inline-flex items-center gap-2 rounded-full border border-line bg-surface px-3 py-1 text-xs font-medium text-ink-soft"
        >
          <span
            className="size-2 rounded-full"
            style={{ backgroundColor: s.color ?? 'var(--subtle)' }}
            aria-hidden="true"
          />
          {s.name}
          {s.isOptional ? <span className="text-subtle">· {t('optional')}</span> : null}
        </li>
      ))}
    </ul>
  )
}
